"use client"

import { AuthFormHeading } from "./auth-form-heading"

import Link from "next/link"
import { ShieldAlert } from "lucide-react"

import { Button } from "@/shared/components/ui/button"

interface KayitKilitliProps {
  hataMesaji: string | null
  onYenidenBasla: () => void
}

/**
 * §1.7 — `KILITLI` terminaldir: aynı `talep_id` ile denemeyi sürdürme, yeni talep aç.
 * Süresi dolan OTP de aynı ekrana düşer.
 */
export function KayitKilitli({ hataMesaji, onYenidenBasla }: KayitKilitliProps) {
  return (
    <div className="space-y-6 text-center">
      <ShieldAlert className="mx-auto size-12 text-destructive" />
      <AuthFormHeading title="Kayıt talebi kapandı">
          {hataMesaji ?? "Bu talep artık kullanılamıyor; yeni bir kayıt oluşturun."}
        </AuthFormHeading>

      <Button className="w-full" onClick={onYenidenBasla}>
        Yeni kayıt oluştur
      </Button>

      <p className="text-sm text-muted-foreground">
        Zaten hesabınız var mı?{" "}
        <Link
          href="/login"
          className="font-medium text-foreground underline-offset-4 hover:underline"
        >
          Giriş yapın
        </Link>
      </p>
    </div>
  )
}
